// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
import type { ViewContext } from '../viewContext';
import { buildInsights } from '../analysis';
import { escapeHtml } from '../utils/format';

export function renderInsights(root: HTMLElement, ctx: ViewContext): void {
  const insights = buildInsights(ctx.data.facilities, ctx.data.meta);

  root.innerHTML = `
    <div class="view-head">
      <h1 class="view-title">What the numbers say</h1>
      <p class="view-sub">
        Findings detected automatically from the ${escapeHtml(ctx.data.meta.reportingYear)} Safeguard data — the biggest
        breaches, the methane story, the industries that dominate, and how the carbon market squared the gap. Click a
        facility chip to open it.
      </p>
    </div>
    <div class="insight-grid">
      ${insights
        .map(
          (ins) => `<div class="insight ${ins.severity}">
            <h3>${escapeHtml(ins.title)}</h3>
            <p>${escapeHtml(ins.body)}</p>
            ${
              ins.facilities.length
                ? `<div class="insight-links">${ins.facilities
                    .map((slug) => {
                      const f = ctx.data.bySlug.get(slug);
                      return f ? `<button class="chip" data-slug="${escapeHtml(slug)}">${escapeHtml(f.name.length > 28 ? f.name.slice(0, 27) + '…' : f.name)}</button>` : '';
                    })
                    .join('')}</div>`
                : ''
            }
          </div>`,
        )
        .join('')}
    </div>
  `;

  root.addEventListener('click', (e) => {
    const chip = (e.target as Element).closest('[data-slug]');
    if (chip) ctx.openFacility(chip.getAttribute('data-slug') as string);
  });
}
